if (!customElements.get('size-chart')) {
    class SizeChart extends HTMLElement {
        constructor() {
            super();
            this.attachOpener();
            this.attachUnitsToggle();
        }

        attachOpener() {
            const drawer = document.querySelector('.js-size-chart-drawer');
            if (drawer) drawer.remove();
            document.body.appendChild(drawer);

            const showSizeChartBtn = this.querySelector('.js-show-size-chart');
            if (showSizeChartBtn) {
                showSizeChartBtn.addEventListener('click', () => {
                    document.querySelector('.js-size-chart-drawer').open(showSizeChartBtn);
                });
            }
        }

        switchColumns(unit) {
            const container = document.getElementById('mySideSizeChart');
            if (!container) return;

            const table = container.querySelector('table');
            if (!table) return;

            // Reduce thead th colspan=2 to 1 (size headers: S, M, L...)
            table.querySelectorAll('thead tr').forEach(row => {
                row.querySelectorAll('th').forEach((th, i) => {
                    if (i === 0) return;
                    if (parseInt(th.getAttribute('colspan') || 1) === 2) {
                        th.setAttribute('colspan', 1);
                    }
                });
            });

            table.querySelectorAll('tbody tr').forEach(row => {
                const cells = row.querySelectorAll('td');
                if (!cells.length) return;

                const firstCellText = cells[0].textContent.trim().toLowerCase();

                // Hide the in/cm unit label row entirely
                const isUnitRow = Array.from(cells).slice(1).every(td => {
                    const t = td.textContent.trim().toLowerCase();
                    return t === 'in' || t === 'cm' || t === '';
                });
                if (isUnitRow) {
                    row.style.display = 'none';
                    return;
                }

                // Measurement rows: cells[1..] are alternating in/cm single columns
                const isMeasurementRow = ['bust', 'length', 'sleeves length', 'shoulder'].some(k => firstCellText.includes(k));
                if (isMeasurementRow) {
                    cells.forEach((td, i) => {
                        if (i === 0) return;
                        const isInCol = (i % 2 === 1); // 1,3,5... = in
                        const isCmCol = (i % 2 === 0); // 2,4,6... = cm
                        if (unit === 'in') {
                            td.style.display = isInCol ? '' : 'none';
                        } else {
                            td.style.display = isCmCol ? '' : 'none';
                        }
                    });
                    return;
                }

                // Size label rows (US-CA, AU-NZ, EU, empty header):
                // These have colspan=2 cells — reduce to 1 to match single visible column above
                cells.forEach((td, i) => {
                    if (i === 0) return;
                    if (parseInt(td.getAttribute('colspan') || 1) === 2) {
                        td.setAttribute('colspan', 1);
                    }
                });
            });

            const currentUnitLabel = document.getElementById('currentUnitSizeChart');
            if (currentUnitLabel) {
                currentUnitLabel.innerText = 'Current is ' + (unit === 'cm' ? 'CM' : 'INCH');
            }
        }

        attachUnitsToggle() {
            // Run on init to apply default state (cm active)
            const activeBtn = document.querySelector('.size-chart-toggle .size-chart-toggle__option.is-active');
            if (activeBtn) {
                this.switchColumns(activeBtn.dataset.unit || 'cm');
            }

            document.querySelectorAll('.size-chart-toggle').forEach(toggle => {
                toggle.addEventListener('click', e => {
                    const btn = e.target.closest('.size-chart-toggle__option');
                    if (!btn) return;

                    toggle.querySelectorAll('.size-chart-toggle__option')
                        .forEach(b => b.classList.remove('is-active'));
                    btn.classList.add('is-active');

                    this.switchColumns(btn.dataset.unit);
                });
            });
        }
    }

    customElements.define('size-chart', SizeChart);
}